import { connect } from 'react-redux';

import {
  enqueueRadioToolTip,
  closeToolTip,
} from 'store/tooltip/tooltip.actions';

const mapStateToProps = (state) => ({
  radioState: state.radio,
  userhistoryRadioState: state.userhistoryRadio,
  tooltipState: state.tooltip,
});

const mapDispatchToProps = (dispatch) => ({
  onRadioMoreToolTip: (key, element, stationuuid) =>
    dispatch(enqueueRadioToolTip(key, element, stationuuid)),
  onCloseToolTip: () => dispatch(closeToolTip()),
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
